import React, { useContext } from "react";
import styles from "./ToggleTooltipButton.module.scss";
import { MdOutlineTipsAndUpdates } from "react-icons/md";
import { TooltipContext } from "../../../context/TooltipContext";

const ToggleTooltipButton = () => {
  const { tooltipsEnabled, toggleTooltips } = useContext(TooltipContext);

  return (
    <label className={styles.toggleWrapper}>
      <input
        type="checkbox"
        checked={tooltipsEnabled}
        onChange={toggleTooltips}
        className={styles.input}
      />
      <span className={styles.slider}>
        <span className={styles.icon}>
          <MdOutlineTipsAndUpdates />
        </span>
      </span>
    </label>
  );
};

export default ToggleTooltipButton;
